import MainLayout from "../components/shared/MainLayout";
import Hero from "../components/hero/Hero";
import ContactDetail from "../components/contact/ContactDetail";
import Location from "../components/contact/Location";

const Contact = () => {
  return (
    <MainLayout>
      <Hero title="Contact Us" link="contact" />
      <ContactDetail />
      <Location />
    </MainLayout>
  );
};

export default Contact;
